const POLICY_VERSION_KEY = 'acceptedPolicyVersion';

export const getAcceptedPolicyVersion = userId => {
  if (!userId) return null;
  return localStorage.getItem(`${POLICY_VERSION_KEY}_${userId}`);
};

export const setAcceptedPolicyVersion = (userId, version) => {
  if (!userId || !version) return;
  localStorage.setItem(`${POLICY_VERSION_KEY}_${userId}`, version);
};

export const clearAcceptedPolicyVersion = userId => {
  if (!userId) return;
  localStorage.removeItem(`${POLICY_VERSION_KEY}_${userId}`);
};

export const clearAllAcceptedPolicyVersions = () => {
  const keys = Object.keys(localStorage);
  keys.forEach(key => {
    if (key.startsWith(POLICY_VERSION_KEY)) {
      localStorage.removeItem(key);
    }
  });
};

export const needsPolicyAcceptance = (userId, currentVersion) => {
  if (!userId || !currentVersion) return false;
  const acceptedVersion = getAcceptedPolicyVersion(userId);
  return acceptedVersion !== currentVersion;
};
